import { useState, useEffect, useCallback } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Configuración y lista de depósitos de la empresa activa.
 *  activo=false => la empresa no usa depósitos (todo funciona como siempre). */
export default function useDepositos(token, logo) {
  const [cfg, setCfg] = useState({ activo: false, modo: "sin_depositos" });
  const [depositos, setDepositos] = useState([]);
  const [cargando, setCargando] = useState(false);

  const recargar = useCallback(async () => {
    if (!token) return;
    setCargando(true);
    try {
      const q = logo ? `?logo_tipo=${logo}` : "";
      const h = { Authorization: `Bearer ${token}` };
      const rc = await fetch(`${API}/admin/depositos/config${q}`, { headers: h });
      if (!rc.ok) { setCfg({ activo: false, modo: "sin_depositos" }); setDepositos([]); return; }
      const c = await rc.json();
      setCfg(c);
      if (c.activo) {
        const rd = await fetch(`${API}/admin/depositos${q}`, { headers: h });
        setDepositos(rd.ok ? await rd.json() : []);
      } else {
        setDepositos([]);
      }
    } catch {
      setCfg({ activo: false, modo: "sin_depositos" });
    } finally {
      setCargando(false);
    }
  }, [token, logo]);

  useEffect(() => { recargar(); }, [recargar]);

  return { cfg, depositos, cargando, recargar, activo: !!cfg.activo };
}
